import React, { Component } from 'react'
import Aux from '../../../../../hoc/Auxiliary/Auxiliary'
import {
  AreaChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Area,
  // Label,
  ResponsiveContainer
} from 'recharts'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import { Grid, Typography } from '@material-ui/core/'
import classes from './style.scss'

class GradeChart extends Component {
  state = {
    gradeData: [],
    grade: []
  }

  static getDerivedStateFromProps = (props, state) => {
    if (props?.gradeData && props?.gradeData !== state.gradeData) {
      // let [grade] = props.gradeData.map((item) => {
      //   let ValueList = item.ValueList.map((val) => {
      //     return {
      //       ...val,
      //       budget: 0,
      //       amount: 0,
      //     }
      //   })
      //   return {
      //     ...item,
      //     ValueList: ValueList,
      //   }
      // })

      return {
        gradeData: props.gradeData
        // grade: grade,
        // CountForceRank: grade.CountForceRank
      }
    }
    return null
  }

  render() {
    let data = []

    if (this.state.grade) {
      data = this.state.gradeData.map(item => {
        return {
          grade: item.value_list_name,
          amount: item.amount
        }
      })
    }
    return (
      <Aux>
        <Grid container direction={'row'} spacing={1}>
          <Grid item>
            <Typography>{this.props.translate('actualGrade')}</Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} className={classes.areaChart}>
            <ResponsiveContainer>
              <AreaChart
                width={500}
                height={400}
                data={data}
                margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                <defs>
                  <linearGradient id='color' x1='0' y1='0' x2='0' y2='1'>
                    <stop offset='5%' stopColor='#82ca9d' stopOpacity={0.8} />
                    <stop offset='95%' stopColor='#82ca9d' stopOpacity={0} />
                  </linearGradient>
                </defs>
                <XAxis dataKey='grade'>
                  {/* <Label value={this.props.translate('grade')} offset={0} position='insideBottom' /> */}
                </XAxis>
                <YAxis>
                  {/* <Label value={this.props.translate('budget')} angle={-90} position='insideLeft' /> */}
                </YAxis>

                <CartesianGrid strokeDasharray='3 5' />
                <Tooltip />
                <Area
                  type='monotone'
                  dataKey='amount'
                  stroke='#82ca9d'
                  fillOpacity={1}
                  fill='url(#color)'
                />
              </AreaChart>
            </ResponsiveContainer>
          </Grid>
        </Grid>
      </Aux>
    )
  }
}

export default withTranslate(GradeChart)
